// extracted by mini-css-extract-plugin
module.exports = {"content":"Description_content__krLnH","columns":"Description_columns__2Joh2","submitBtn":"Description_submitBtn__Xip4O"};